import { Middleware } from "openapi-fetch";
import i18n from "../../i18n";
import { TOKEN_INFO_SESSION_STORAGE_KEY } from "../../constants";
import { getVariantValue } from "../variantTunnel";
import { WafBlockError } from "./WafBlockError";

// WAFのブロック時にカスタムレスポンスへ付与されるヘッダー
const WAFBLOCK_HEADER = "X-Blocked-By-Waf";

// WAFのメンテナンスブロック時にカスタムレスポンスへ付与されるヘッダー
const MAINTENANCE_MODE_HEADER = "X-Maintenance-Mode";

export const wafMiddleware: Middleware = {
  onResponse({ response }) {
    const { status, headers } = response;

    if (status == 503 && headers.get(MAINTENANCE_MODE_HEADER) === "True") {
      const message = i18n.t("Error.waf.maintenance");
      window.alert(message);
      window.location.reload();
      return Promise.reject(new WafBlockError(message));
    }

    if (status == 403 && headers.get(WAFBLOCK_HEADER) === "True") {
      const message = i18n.t("Error.waf.blocked");
      window.alert(message);
      window.location.reload();
      return Promise.reject(new WafBlockError(message));
    }
  },
};

export const authMiddleware: Middleware = {
  onRequest({ request }) {
    if (request.headers.has("Authorization")) return;
    const tokenInfoStr = sessionStorage.getItem(TOKEN_INFO_SESSION_STORAGE_KEY);
    const tokenInfo = JSON.parse(tokenInfoStr || "null");
    if (tokenInfo) {
      request.headers.set("Authorization", `Bearer ${tokenInfo.access_token}`);
    }
  },
};

export const variantTunnelMiddleware: Middleware = {
  onRequest({ request }) {
    const variantValue = getVariantValue();
    if (variantValue === null) return;
    request.headers.set("X-Backend-Variant", variantValue);
  },
};
